import { render, staticRenderFns } from "./AccessorialsDrayage.vue?vue&type=template&id=cec5357c&scoped=true"
import script from "./AccessorialsDrayage.vue?vue&type=script&lang=js"
export * from "./AccessorialsDrayage.vue?vue&type=script&lang=js"
import style0 from "./AccessorialsDrayage.vue?vue&type=style&index=0&id=cec5357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec5357c",
  null
  
)

export default component.exports